import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import './Score.module.scss'

const propTypes = {
  color: PropTypes.string,
  numerator: PropTypes.number,
  denominator: PropTypes.number,
  scoreLabel: PropTypes.node,
}

function Score(props) {
  const { color = '#ccc', numerator = 0, denominator = 0, scoreLabel = null } = props ?? {}

  return (
    <div className="Uic-Score-score-container">
      <span
        className="font-bolder"
        style={{
          fontSize: '6rem',
          color,
        }}
      >
        {numerator}
      </span>
      <span
        className="font-bolder"
        style={{
          color,
          fontSize: '2rem',
        }}
      >
        /{denominator}
      </span>

      {scoreLabel !== undefined && <span className={clsx('Uic-Score-score-label', 'font-color-6')}>{scoreLabel}</span>}
    </div>
  )
}

Score.propTypes = propTypes

export default Score
